import { render, staticRenderFns } from "./SubstituteTable.vue?vue&type=template&id=fc11ecda&"
import script from "./SubstituteTable.vue?vue&type=script&lang=js&"
export * from "./SubstituteTable.vue?vue&type=script&lang=js&"
import style0 from "./SubstituteTable.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fc11ecda')) {
      api.createRecord('fc11ecda', component.options)
    } else {
      api.reload('fc11ecda', component.options)
    }
    module.hot.accept("./SubstituteTable.vue?vue&type=template&id=fc11ecda&", function () {
      api.rerender('fc11ecda', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/global/management/vistas/components/SubstituteTable.vue"
export default component.exports